<template>
  <div class="messenger">

    <div class="hero">
      <div class="hero-body">
        <div class="container">
          <h1 class="title is-size-1">Broadcast Messages</h1>
          <p class="subtitle">All Messages</p>
        </div>
      </div>
    </div>

    <div class="container">

      <div v-if="pleaseWait">
        <p>Please wait...</p>
      </div>

      <br/>

      <div>
        <div class="is-pulled-right">
          <span><a @click="addNewMessage" style="color: white" class="is-link">Add new message</a><i class="fas fa-plus-circle has-text-info" @click="addNewMessage" title="ADD NEW MESSAGE"></i></span>
        </div>
      </div>
      
      <div v-if="showAddNew">
        <div class="box" style="position: absolute; width: 90%; margin-left: 5%; margin-right: 5%;">
          <p class="is-size-5 has-text-weight-bold">Post new msg:</p>
          <div class="box" style="background-color: lightgray;">
            <div class="columns">
              <div class="column">
                <p>Message Type:</p>
                <div class="select is-rounded">
                  <select v-model="message.level">
                    <option v-for="level in level_list" v-bind:key="level.level_name" v-bind:value="level.level_name">
                      {{ level.level_name }}
                    </option>
                  </select>
                </div>
              </div>
            </div>
            <div class="columns">
              <div class="column">
                <p>Subject:</p>
                <input type="text" v-model="message.title" class="input is-primary" placeholder="subject"/>
              </div>
            </div>
            <div class="columns">
              <div class="column">
                <p>Body:</p>
                <textarea class="textarea" v-model="message.description" placeholder="message"></textarea>
              </div>
            </div>
            <div class="columns">
              <div class="column">
                <p>Start date:</p>
                <input class="input" type="date" v-model="message.start_date" style="width: 200px;"/>
              </div>
              <div class="column">
                <p>End date:</p>
                <input class="input" type="date" v-model="message.end_date" style="width: 200px;"/>
              </div>
            </div>
            <div class="columns is-mobile">
              <div class="column">
                <button class="button is-primary is-pulled-right" @click="saveNewMessage" title="SAVE"><i class="fas fa-save"> Save</i></button>
              </div>
              <div class="column">
                <button class="button is-danger" @click="cancelNewMessage" title="CANCEL"><i class="fas fa-times-circle"></i> Cancel</button>
              </div>
            </div>
          </div>
        </div>
      </div>

      <br/>

      <div class="box messages" v-if="messages.length > 0">
        <div v-for="(message,index) in messages" :key="message._id" class="box message">
          <div class="columns is-mobile">
            <div class="column is-10">
              <p class="is-size-5 has-text-bold">{{ message.title }}</p>
            </div>
            <div class="column is-2">
              <span v-if="message.level === 'warning'"><i class="fas fa-skull-crossbones"></i></span>
              <span v-if="message.level === 'feature'"><i class="fas fa-crow"></i></span>
              <span v-if="message.level === 'information'"><i class="fas fa-info"></i></span>
              <span v-if="message.level === 'reminder'"><i class="fas fa-bell"></i></span>
              <span v-if="message.level === 'bug'"><i class="fas fa-bug"></i></span>
            </div>
          </div>
          <div>
            <p>{{ message.description }}</p>
          </div>
          <hr/>
          <div>
            <p class="is-size-7">{{ message.start_date | formatDate }} to {{ message.end_date | formatDate }}</p>          
          </div>
          <div class="is-size-7">
            <i class="fas fa-trash has-text-danger" v-on:click="deleteMessage(message,index)" title="DELETE"> </i>
            <span class="has-text-danger is-link" v-on:click="deleteMessage(message,index)">delete</span>
          </div>
          <!--
          <div class="columns">
            <div class="column">
                <i class="fas fa-edit has-text-primary" v-on:click="editMessage()" title="EDIT"> edit</i>
            </div>
            <div class="column">
                <i class="fas fa-trash has-text-danger" v-on:click="deleteMessage()" title="DELETE"> delete</i>
            </div>
          </div>
          -->
        </div>

      </div>

    </div>
    <br/>
    <br/>
    <br/>
    <br/>
    <br/>
    <br/>
    <br/>
    <br/>
    <br/>
    <br/>
    <br/>
    <br/>
    <br/>
    <br/>
    <br/>
    <br/>
  </div>
</template>

<script>
import axios from "axios";
import moment from 'moment';

export default {
  name: 'admin',
    components : {
    },
    computed: {
    },
    data () {
        return {
            debugMode: (process.env.VUE_APP_DEBUG_MODE === "true" ? true : false),
            publicPath: process.env.BASE_URL,
            message: {
              level: "reminder",
              start_date: moment().startOf('week').format('YYYY-MM-DD'),
              end_date: moment().endOf('week').format('YYYY-MM-DD'),
              title: '',
              description: ''
            },
            messages: [],
            level_list: [{level_name:'warning'},{level_name:'feature'},{level_name:'information'},{level_name:'reminder'},{level_name:'bug'}],
            errorMessage: '',
            showError: false,
            pleaseWait: true,
            showAddNew: false
        }
    },
    methods:{
      getMessages() {
        var url = (this.debugMode ? "http://localhost:8080/messages/" : "https://axes2api.azurewebsites.net/messages/")
        this.messages = [];
        this.pleaseWait = true;

        axios.get(url)
          .then((response) => {
            this.messages = response.data; 
            this.pleaseWait = false;
          }, (error) => {
            this.pleaseWait = false;
          });
      },
      addNewMessage() {
        this.toggleShowAddNew();
      },
      toggleShowAddNew() {
        this.showAddNew = !this.showAddNew;
      },
      saveNewMessage() {
        var url = (this.debugMode ? "http://localhost:8080/message/" : "https://axes2api.azurewebsites.net/message/")
        var token = this.$parent.getApiToken();
        axios.post(url, 
          {
            title: this.message.title,
            description: this.message.description,
            level: this.message.level,
            start_date: this.message.start_date,
            end_date: this.message.end_date
          },
          {
            headers: {
                authorization: token
              }
          }
        )
        .then((response) => {
          alert("Message added.");      
          this.messages.push(this.message);      
          this.message = {};
          this.toggleShowAddNew();
       }, (error) => {
          alert("Error adding message to Axes2.");
        });
      },
      cancelNewMessage() {
        this.message = {};
        this.toggleShowAddNew();
      },
      editMessage() {
        alert("edit");
      },
      deleteMessage(message, index) {
        if (confirm('Are you sure you want to delete this broadcast message?')) {
          var messageId = message._id;

          var url = (this.debugMode ? "http://localhost:8080/message/" : "https://axes2api.azurewebsites.net/message/")
          url += messageId;
          
          //console.log("deleteMessage url:" + url);

          var token = this.$parent.getApiToken();

          axios.delete(url, {
            headers: {
              authorization: token
            },
            data: {
            }
          })
          .then((response) => {
            alert('Message Deleted.');
            //console.log(response);
            
            this.messages.splice(index, 1);
            
          }, (error) => {
            alert("Error deleting message.");
            console.log(error);
          });
        }
      },
      isAdmin() {
          return this.$parent.isAdmin();
      }
    },
    mounted(){
      this.getMessages();
    }
}
</script>

<style scoped>
  .messenger {
    font-family: Verdana;
  }
  .hero {
    background-color: black;
  }
  .messages {
    background-color: grey; 
    max-width: 350px; 
    margin: auto;
    margin-bottom: 25px;
    margin-top: 10px;
  }
  .message {
    background-color: white; 
    padding-bottom: 30px;
  }
</style>

